/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
const observedAttributes = {
    TYPE: 'type',
    DISABLED: 'disabled',
    POPOVER_ICON: 'popover-icon',
    DENSE: 'dense',
    TABINDEX: 'tabindex'
};
const attributes = {
    ...observedAttributes
};
const classes = {
    ROOT: 'forge-button',
    POPOVER_ICON: 'forge-button__popover-icon',
    WITH_ANCHOR: 'with-anchor'
};
const selectors = {
    ROOT: '[part=root]',
    DEFAULT_SLOT: 'slot:not([name])',
    END_SLOT: 'slot[name=end]'
};
export const BASE_BUTTON_CONSTANTS = {
    observedAttributes,
    attributes,
    selectors,
    classes
};
